import { makePostApiCall } from "../../../shared/makeApiCall";
import type { ApiMessage, ApiResult } from "../../../types/api";
import type { UpdatePasswordPayload } from "../../../types/users";

export function UserViewModel(logout: () => void) {
  const userId = Number(localStorage.getItem("id"));

  const updateAccountPassword = async function (
    values: UpdatePasswordPayload,
  ): Promise<ApiResult<ApiMessage>> {
    const callResult = await makePostApiCall<ApiMessage, UpdatePasswordPayload>(
      `users/password/${userId}`,
      values,
    );

    if (!callResult.success && callResult.errorStatus === 401) {
      logout();
    }
    return callResult;
  };

  return { updateAccountPassword };
}
